import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _, { property } from "lodash"
import axios from "axios"
import settings from "settings"
import { loadingStatus, getPayload } from "actions"
import ArcReviewLot from "containers/modals/arcReviewLot"
import ArcFinalReview from "containers/modals/arcFinalReview"
import MasterArcModal from "containers/modals/masterArcModal"
import moment from "moment"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"
import getData from "helpers/asyncSubmitData"
import FullTable from "components/FullTable"
import Modal from "react-responsive-modal"
import { Formik, Field, Form } from "formik"
import superagent from "superagent"
import * as Yup from "yup"
import ArcModal from "containers/entry/modals/arcSubmitLot"
import fieldStatus from "helpers/fieldStatus"
import helpers from "helpers/helpers"

class ArcManagement extends Component {
	//? If an elevation is under review, it will be null.  If it's 0, that means rejected.
	//? Final review-  stored in arc_data, if it's false, it's rejected.  If it's true, it's approved.  If it's null or undefined, it's under review.
	// The dates for final review are:
	// fr_review_date is when the builder wants the review to happen
	// fr_date is when the builder submits that request ^
	// fr_approved_date is when ARC approved the final review
	// fr_schedule_date is when the final review is scheduled by ARC to be done
	constructor(props) {
		super(props)

		this.materialShell = {
			name: "",
			type: "",
			properties: [],
			image: "",
			brand: "",
			id: null,
		}

		this.colorShell = {
			name: "",
			brand: "",
			properties: [],
			image: "",
			id: null,
		}

		this.state = {
			data: [],
			docs: [],
			modal: false,
			finalModal: false,
			alertError: false,
			alertSuccess: false,
			materialsOpen: false,
			colorsOpen: false,
			filtered: [],
			materialData: _.clone(this.materialShell),
			colorData: _.clone(this.colorShell),
			alertTitle: "",
			alertText: "",
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "User",
					accessor: "user",
					filterMethod: (f, r) => helpers.tableText(f, r, "user"),
				},
				{
					Header: "Submitted Date",
					accessor: "date",
					Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
					filterMethod: (f, r) => helpers.dateFilter(f, r, "MM/DD/YY"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: settings.renameConditional || "Conditional Approval",
					accessor: "conditional",
					filterMethod: (f, r) => helpers.tableText(f, r, "conditional"),
				},
				// This was for provident, not sure it's needed for others, so hiding.
				...(settings?.renameConditional
					? [
							{
								Header: `${settings.renameConditional} Date`,
								accessor: "conditional_date",
								filterMethod: (f, r) => helpers.tableText(f, r, "conditional_date"),
							},
					  ]
					: []),
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				...(settings?.arcFeeStatus
					? [
							{
								Header: "Fee Status",
								accessor: "fee_status",
								filterMethod: (f, r) => helpers.tableText(f, r, "fee_status"),
								Cell: (row) => (
									<span
										className="font-bold"
										style={{ color: row.value === "Paid" ? "green" : "red" }}>
										{row.value}
									</span>
								),
							},
					  ]
					: []),
				{
					Header: "",
					accessor: "edit",
				},
			],
			finalColumns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "User",
					accessor: "user",
					filterMethod: (f, r) => helpers.tableText(f, r, "user"),
				},
				{
					Header: "Submitted Date",
					accessor: "submit_date",
					Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY LT") : ""),
				},
				{
					Header: "Requested Review Date",
					accessor: "final_review_date",
				},
				{
					Header: "Scheduled Review Date",
					accessor: "final_review_scheduled",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "",
					accessor: "edit",
				},
			],
			masterColumns: [
				{
					Header: "ID",
					accessor: "id",
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "User",
					accessor: "user",
					filterMethod: (f, r) => helpers.tableText(f, r, "user"),
				},
				{
					Header: "Submitted Date",
					accessor: "date",
					Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
					filterMethod: (f, r) => helpers.dateFilter(f, r, "MM/DD/YY"),
				},
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "",
					accessor: "view",
				},
			],
			lotColumns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Block",
					accessor: "block",
				},
				{
					Header: "Section",
					accessor: "section",
				},
				{
					Header: "Floorplan",
					accessor: "floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "floorplan"),
				},
				{
					Header: "Elevation",
					accessor: "elevation",
					filterMethod: (f, r) => helpers.tableText(f, r, "elevation"),
				},
				{
					Header: "Sqft",
					accessor: "sqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Brick",
					accessor: "brick",
					filterMethod: (f, r) => helpers.tableText(f, r, "brick"),
				},
				{
					Header: "Stone",
					accessor: "stone",
					filterMethod: (f, r) => helpers.tableText(f, r, "stone"),
				},
				{
					Header: "Trim",
					accessor: "trim",
					filterMethod: (f, r) => helpers.tableText(f, r, "trim"),
				},
				{
					Header: "Siding",
					accessor: "siding",
					filterMethod: (f, r) => helpers.tableText(f, r, "siding"),
				},
				{
					Header: "Stucco",
					accessor: "stucco",
					filterMethod: (f, r) => helpers.tableText(f, r, "stucco"),
				},
				{
					Header: "Accent Color",
					accessor: "accent_color",
					filterMethod: (f, r) => helpers.tableText(f, r, "accent_color"),
				},
				{
					Header: "Garage Color",
					accessor: "garage_color",
					filterMethod: (f, r) => helpers.tableText(f, r, "garage_color"),
				},
				{
					Header: "Roof Color",
					accessor: "roof_color",
					filterMethod: (f, r) => helpers.tableText(f, r, "roof_color"),
				},
				{
					Header: "Approval Status",
					accessor: "approval_status",
					filterMethod: (f, r) => helpers.tableText(f, r, "approval_status"),
				},
				{
					Header: "Approval Month",
					accessor: "approval_month",
					filterMethod: (f, r) => helpers.tableText(f, r, "approval_month"),
				},
				{
					Header: "Final Submission",
					accessor: "submit_date",
				},
				{
					Header: "Final Requested Review",
					accessor: "final_review_date",
				},
				{
					Header: "Final Scheduled Review",
					accessor: "final_review_scheduled",
				},
				{
					Header: "Final Approval",
					accessor: "final_approval_date",
				},
				{
					Header: "Final Days Difference",
					accessor: "days_difference",
				},
				{
					Header: "Plan File",
					accessor: "plan_file",
				},
				{
					Header: settings.renameConditional ? settings.renameConditional : "Conditional File",
					accessor: "conditional_file",
				},
				{
					Header: "Approval File",
					accessor: "approval_file",
				},
				{
					Header: "View",
					accessor: "view",
				},
			],
			awaitingFinalColumns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "Lot",
					accessor: "lot",
				},
				{
					Header: "Block",
					accessor: "block",
				},
				{
					Header: "Section",
					accessor: "section",
				},
				{
					Header: "Floorplan",
					accessor: "floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "floorplan"),
				},
				{
					Header: "Complete Date",
					accessor: "complete_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "complete_date"),
				},
			],
			materials: [
				{
					Header: "Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Brand",
					accessor: "brand",
					filterMethod: (f, r) => helpers.tableText(f, r, "brand"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => {
						if (r.name?.props?.children?.toLowerCase().includes(f.value.toLowerCase())) {
							return true
						}
					},
				},
				{
					Header: "Available In",
					accessor: "properties",
				},
				{
					Header: "Image",
					accessor: "image",
				},
			],
			colors: [
				{
					Header: "Brand",
					accessor: "brand",
					filterMethod: (f, r) => helpers.tableText(f, r, "brand"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => {
						if (r.name?.props?.children?.toLowerCase().includes(f.value.toLowerCase())) {
							return true
						}
					},
				},
				{
					Header: "Available In",
					accessor: "properties",
				},
				{
					Header: "Image",
					accessor: "image",
				},
			],
			styles: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Property",
					accessor: "property",
				},
				{
					Header: "View",
					accessor: "view",
				},
			],
			defaultSorted: [],
			masterOpen: false,
			stylesOpen: false,
			styleData: false,
			confirmMaterialDisable: false,
			confirmColorDisable: false,
			masterData: {},
			id: false,
			lotData: {},
			lotInfoModal: false,
		}
		this.materialFileRef = React.createRef()
		this.colorFileRef = React.createRef()
	}

	componentDidMount() {
		//this.props.loadingStatus(true)
		//this.getARC()
	}

	componentDidUpdate(prevProps) {
		try {
			//? This is for when an admin goes in and edits a master plan, the flare goes out and updates payload, which this catches and then updates hte masterData state.
			if (prevProps.payloadStatus !== this.props.payloadStatus && this.state.masterData) {
				let plan = _.find(this.props.payload.public.floorplans, { id: this.state.masterData?.id })
				if (plan) this.setState({ masterData: plan })
			}
		} catch (e) {
			console.log(e)
		}
	}

	getARC = () => {
		//console.log('%c' + `Getting Documents..`, 'background: #222; color: #bada55')
		var userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getARC",
				{},
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				this.setState({ docs: response.data }, () => {
					this.props.loadingStatus(false)
				})
			})
			.catch((error) => {
				console.log(error)
				this.props.loadingStatus(false)
			})
	}

	buildTable(type) {
		let data = []
		let filtered = _.filter(this.props.payload.exec.lots, (r) => {
			if (type && r?.arc_data?.current_status !== "conditional") return false
			if (type === false && r?.arc_data?.current_status !== "rejected") return false
			if (this.props.activeProperties.includes(r.property) && !r.arc_approved && r.arc_data) {
				return true
			}
		})
		_.forEach(filtered, (v, k) => {
			let user = ""
			if (v.arc_data && v.arc_data.user) {
				try {
					let userLook = _.find(this.props.payload.users, { id: v.arc_data.user })
					if (!userLook) throw `Cannot find user who submitted arc lot.`
					user = `${userLook.first} ${userLook.last}`
				} catch (e) {
					console.error(e)
				}
			}
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let status = _.get(v, `arc_data.current_status`)
			if (status === "partialSave") return
			if (status) status = _.capitalize(status)
			if (status === "Conditional" && settings.renameConditional) status = settings.renameConditional
			if (status === "Conditional" && settings?.enabled?.arcSkipConditional && !type) return
			let fee_status = ""
			if (settings.arcFeeStatus && v?.addl?.feesTable) {
				// determine fee status
				let isPaid = true
				_.forEach(v.addl.feesTable, (fee) => {
					if (!fee.status) isPaid = false
				})
				fee_status = isPaid ? "Paid" : "Unpaid"
			}
			let ret = {
				community: (community && community.name) || "",
				builder: (builder && builder.name) || "",
				user,
				address: v.address,
				date: _.has(v, `arc_data.addedDate`) ? v.arc_data.addedDate : false,
				conditional: _.has(v, `arc_data.conditional_approval`) ? "Yes" : null,
				rejection_reason: _.get(v, `arc_data.reason`) || null,
				conditional_date: v.arc_data?.conditional_date
					? moment.unix(v.arc_data.conditional_date).format("MM/DD/YY")
					: null,
				status,
				fee_status,
			}
			ret.edit = (
				<a
					onClick={() => {
						this.setState({ id: v.id, modal: true })
					}}>
					View Plans
				</a>
			)
			data.push(ret)
		})
		return data
	}

	buildFinalReview() {
		let data = []
		let filtered = _.filter(this.props.payload.exec.lots, (r) => {
			let status = _.get(r, `arc_data.fr`)
			if (this.props.activeProperties.includes(r.property) && status === null) {
				return true
			}
		})
		_.forEach(filtered, (v, k) => {
			let user = ""
			if (v.arc_data && v.arc_data.fr_user) {
				try {
					let userLook = _.find(this.props.payload.users, { id: v.arc_data.fr_user })
					if (!userLook) throw `Cannot find user who submitted arc lot.`
					user = `${userLook.first} ${userLook.last}`
				} catch (e) {
					console.error(e)
				}
			}
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let finalDaysDiff = null
			if (v.arc_data?.fr_approved_date && v.arc_data?.fr_review_date) {
				finalDaysDiff = moment
					.unix(v.arc_data.fr_approved_date)
					.diff(moment.unix(v.arc_data.fr_review_date), "days")
			}
			let ret = {
				community: (community && community.name) || "",
				builder: (builder && builder.name) || "",
				user,
				address: v.address,
				final_approval_date: v.arc_data?.fr_approved_date
					? moment.unix(v.arc_data?.fr_approved_date).format("MM/DD/YY")
					: null,
				final_review_date: v.arc_data?.fr_review_date
					? moment.unix(v.arc_data.fr_review_date).format("MM/DD/YY")
					: null,
				final_review_scheduled: v.arc_data?.fr_schedule_date
					? moment.unix(v.arc_data?.fr_schedule_date).format("MM/DD/YY")
					: null,
				days_difference: finalDaysDiff,
				submit_date: _.has(v, `arc_data.fr_date`) ? v.arc_data.fr_date : false,
			}
			ret.edit = (
				<a
					onClick={() => {
						this.setState({ id: v.id, finalModal: true })
					}}>
					View Submission
				</a>
			)
			data.push(ret)
		})
		return data
	}

	alert = (type) => {
		this.setState({ [type]: false })
		this.props.getPayload()
	}

	buildMaster = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplans, (v) => {
			let add = false // track whether or not this FP ends up in teh list after checking master plan for UR/Rejected first, then checks if there's any elevations that are UR
			let property, sp, status
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			if (v.arc_approved && typeof v.arc_approved == "object") {
				_.forEach(v.arc_approved, (r) => {
					if (r.approved == false && this.props.activeProperties.includes(r.property) && v.status == 1) {
						property = _.find(this.props.payload.public.properties, { id: r.property })
						sp = _.find(this.props.payload.users, { id: r.user })
						v.property = r.property
						status = "Under Review - Master Plan"
						if (r.rejected) {
							status = "Rejected" // dont need?
							return
						}
						add = true
						return
					}
				})
			}
			//? now check for elevations on this plan that are under review.
			if (!add) {
				let elevations = _.filter(this.props.payload.public.elevations, {
					floorplan: v.id,
					property: this.props.activeProperties[0],
				})
				_.forEach(elevations, (e) => {
					// if an elevation is under review, add this to the list
					if (e.approval_status === null) {
						property = _.find(this.props.payload.public.properties, { id: e.property })
						sp = _.find(this.props.payload.users, { id: e.user })
						v.property = e.property
						add = true
						status = "Under Review - Elevation"
						return
					}
				})
			}
			if (add) {
				ret.push({
					id: v.id,
					name: v.name,
					property: property.name || "",
					builder: builder.name || "",
					user: sp ? `${sp.first} ${sp.last}` : "",
					date: v.addedDate,
					arc_review_notes: v.arc_review_notes,
					arc_reviewer_files: v.arc_reviewer_files,
					status,
					view: (
						<button className="btn" onClick={() => this.setState({ masterData: v, masterOpen: true })}>
							View Plan
						</button>
					),
				})
			}
		})
		return ret
	}

	buildLots = () => {
		let ret = []
		let prop = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (!["conditional", "approved"].includes(v.arc_data?.current_status)) return
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			let date = ""
			if (v.arc_data && v.arc_data.approval_date) {
				date = moment.unix(v.arc_data.approval_date).format("MMMM YY")
			}
			let plan_file
			if (v.arc_data?.fr_plan_file) {
				plan_file = (
					<a href={`${settings.s3}${v.arc_data.fr_plan_file}`} target="_blank">
						View Plan
					</a>
				)
			}
			let conditional_file
			if (v.arc_data?.conditional_file) {
				conditional_file = (
					<a href={`${settings.s3}${v.arc_data.conditional_file}`} target="_blank">
						{settings.renameConditional ? `View File` : "View Conditional"}
					</a>
				)
			}
			let approval_file
			if (v.arc_data?.approval_file) {
				approval_file = (
					<a href={`${settings.s3}${v.arc_data.approval_file}`} target="_blank">
						View Approval
					</a>
				)
			}
			let finalDaysDiff = null
			if (v.arc_data?.fr_approved_date && v.arc_data?.fr_review_date) {
				finalDaysDiff = moment
					.unix(v.arc_data.fr_approved_date)
					.diff(moment.unix(v.arc_data.fr_review_date), "days")
			}
			let approval_status
			if (v.arc_data?.current_status === "approved") approval_status = "Approved"
			else if (v.arc_data?.current_status === "rejected") approval_status = "Rejected"
			else if (v.arc_data?.current_status === "conditional")
				approval_status = settings.renameConditional || "Conditional Approval"
			let pub = this.props.payload.public
			let f = {
				address: v.address,
				builder: builder ? builder.name : "",
				community: prop ? prop.name : "",
				floorplan: fp ? fp.name : "",
				elevation: v.elevation,
				sqft: v.sqft,
				lot: v.lot,
				block: v.block,
				section: v.section_name,
				brick: helpers.outputMaterial("brick", v.brick, pub),
				stone: helpers.outputMaterial("stone", v.stone, pub),
				trim: helpers.outputMaterial("trim", v.trim, pub),
				siding: helpers.outputMaterial("siding", v.siding, pub),
				stucco: helpers.outputMaterial("stucco", v.stucco, pub),
				garage_color: helpers.outputMaterial("garage_color", v.garage_color, pub),
				accent_color: helpers.outputMaterial("accent_color", v.accent_color, pub),
				roof_color: helpers.outputMaterial("roof_color", v.roof_color, pub),
				approval_month: date,
				approval_status,
				plan_file,
				conditional_file,
				approval_file,
				submit_date: v.arc_data?.fr_date ? moment.unix(v.arc_data?.fr_date).format("MM/DD/YY") : null,
				final_approval_date: v.arc_data?.fr_approved_date
					? moment.unix(v.arc_data?.fr_approved_date).format("MM/DD/YY")
					: null,
				final_review_scheduled: v.arc_data?.fr_schedule_date
					? moment.unix(v.arc_data?.fr_schedule_date).format("MM/DD/YY")
					: null,
				final_review_date: v.arc_data?.fr_review_date
					? moment.unix(v.arc_data.fr_review_date).format("MM/DD/YY")
					: null,
				days_difference: finalDaysDiff,
				view: (
					<a
						onClick={() => {
							this.setState({ lotData: v, lotInfoModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})

		return ret
	}

	buildAwaitingFinal = () => {
		let ret = []
		let prop = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		let lots = _.filter(this.props.payload.exec.lots, (r) => {
			if (r.complete_date && !r.arc_data?.fr && !r.model) return true
		})
		_.forEach(lots, (v) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			let f = {
				address: v.address,
				builder: builder ? builder.name : "",
				community: prop ? prop.name : "",
				floorplan: fp ? fp.name : "",
				elevation: v.elevation,
				sqft: v.sqft,
				lot: v.lot,
				block: v.block,
				section: v.section_name,
				complete_date: moment.unix(v.complete_date).format("MM/DD/YY"),
			}
			ret.push(f)
		})

		return ret
	}

	excelClean = (data) => {
		let ret = []
		_.forEach(data, (v, ind) => {
			_.forEach(v._original, (r, k) => {
				if (k === "image") {
					data[ind]._original[k] = r.props.children.props.alt
				} else if (r && typeof r === "object") {
					data[ind]._original[k] = r.props.children
				}
			})
			ret.push(v)
		})
		return ret
	}

	buildMaterials = () => {
		let ret = []
		_.forEach(this.props.payload.public.arc_materials, (v) => {
			//if (!v?.properties?.includes(this.props.activeProperties[0])) return
			let type = _.find(this.props.payload.public.arc_material_types, { id: v.type })
			let properties = ""
			_.forEach(v.properties, (p) => {
				let prop = _.find(this.props.payload.public.properties, { id: p })
				properties += `${prop.name}, `
			})
			properties = properties.slice(0, -2)
			let f = {
				type: type ? type.name : "",
				id: v.id,
				brand: v.brand,
				name: (
					<a
						className="underline font-semibold"
						onClick={() => this.setState({ materialData: v, materialsOpen: true })}>
						{v.name}
					</a>
				),
				image: v.image ? (
					<a href={`${settings.s3}${v.image}`} target="_blank">
						<img className="w-20" src={`${settings.s3}${v.image}`} alt={v.name} />
					</a>
				) : null,
				properties,
			}
			ret.push(f)
		})
		return ret
	}

	buildCols = (type) => {
		return [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "User",
				accessor: "user",
				filterMethod: (f, r) => helpers.tableText(f, r, "user"),
			},
			{
				Header: "Submitted Date",
				accessor: "date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.dateFilter(f, r, "MM/DD/YY"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: settings.renameConditional || "Conditional Approval",
				accessor: "conditional",
				filterMethod: (f, r) => helpers.tableText(f, r, "conditional"),
			},
			...(type === false
				? [
						{
							Header: "Rejection Reason",
							accessor: "rejection_reason",
							filterMethod: (f, r) => helpers.tableText(f, r, "rejection_reason"),
						},
				  ]
				: []),
			// This was for provident, not sure it's needed for others, so hiding.
			...(settings?.renameConditional
				? [
						{
							Header: `${settings.renameConditional} Date`,
							accessor: "conditional_date",
							filterMethod: (f, r) => helpers.tableText(f, r, "conditional_date"),
						},
				  ]
				: []),
			{
				Header: "Status",
				accessor: "status",
				filterMethod: (f, r) => helpers.tableText(f, r, "status"),
			},
			...(settings?.arcFeeStatus
				? [
						{
							Header: "Fee Status",
							accessor: "fee_status",
							filterMethod: (f, r) => helpers.tableText(f, r, "fee_status"),
							Cell: (row) => (
								<span className="font-bold" style={{ color: row.value === "Paid" ? "green" : "red" }}>
									{row.value}
								</span>
							),
						},
				  ]
				: []),
			{
				Header: "",
				accessor: "edit",
			},
		]
	}

	buildColors = () => {
		let ret = []
		_.forEach(this.props.payload.public.arc_colors, (v) => {
			//if (!v?.properties?.includes(this.props.activeProperties[0])) return
			let properties = ""
			_.forEach(v.properties, (p) => {
				let prop = _.find(this.props.payload.public.properties, { id: p })
				properties += `${prop.name}, `
			})
			properties = properties.slice(0, -2)
			let f = {
				id: v.id,
				brand: v.brand,
				name: (
					<a
						className="underline font-semibold"
						onClick={() => this.setState({ colorData: v, colorsOpen: true })}>
						{v.name}
					</a>
				),
				image: v.image ? (
					<a href={`${settings.s3}${v.image}`} target="_blank">
						<img className="w-20" src={`${settings.s3}${v.image}`} alt={v.name} />
					</a>
				) : null,
				properties,
			}
			ret.push(f)
		})
		return ret
	}

	buildStyles = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplan_classifications, (v) => {
			if (v.property !== this.props.activeProperties[0]) return
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let f = {
				name: v.name,
				property: property ? property.name : "",
				view: (
					<a
						onClick={() => {
							this.setState({ styleData: v, stylesOpen: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			}
			ret.push(f)
		})
		return ret
	}

	materialValidation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			type: Yup.number().required("Required"),
			properties: Yup.array().min(1, "Select at least one property").required("Required"),
		})
	}

	colorValidation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			properties: Yup.array().min(1, "Select at least one property").required("Required"),
		})
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	stylesListMaterialSelects = (f) => {
		let ret = []
		_.forEach(this.props.payload.public.arc_material_types, (v) => {
			let opts = []
			_.forEach(this.props.payload.public.arc_materials, (m) => {
				if (m.type === v.id && m.properties.includes(this.props.activeProperties[0])) {
					opts.push({ value: m.id, label: m.name })
				}
			})
			opts = _.sortBy(opts, "label")
			ret.push(
				<li className={`w-full px-2 pt-6`} key={v.dbName}>
					<label htmlFor={v.dbName}>{v.name}</label>
					{f.errors[v.dbName] && f.touched[v.dbName] && (
						<div className="form__message">{f.errors[v.dbName]}</div>
					)}
					<ReactSelect
						name={v.dbName}
						options={opts}
						value={f.values[v.dbName]}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
						isMulti
					/>
				</li>
			)
		})
		return ret
	}

	render() {
		if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to administer.</h1>
				</div>
			)
		}
		let imageFile = this.state.materialData?.image ? (
			<a href={`${settings.s3}${this.state.materialData?.image}`} target="_blank" className="small">
				{" "}
				View File
			</a>
		) : (
			""
		)
		return (
			<div className="documents">
				<Title title="ARC Management" />
				<div className="content">
					{settings?.enabled?.arcPendingLotTable ? (
						<>
							<h2>
								{settings.renameConditional
									? settings.renameConditional
									: "Conditional Site Plan Submissions"}
							</h2>
							<FullTable
								data={this.buildTable(true)}
								columns={this.buildCols(true)}
								name="arcManagement__lotPlan"
								title="ARC"
								defaultSorted={[
									{
										id: "date",
										desc: false,
									},
								]}
							/>
						</>
					) : null}
					<h2>Site Plan Rejections</h2>
					<FullTable
						data={this.buildTable(false)}
						columns={this.buildCols(false)}
						name="arcManagement__lotPlanRejections"
						title="ARC"
						defaultSorted={[
							{
								id: "date",
								desc: false,
							},
						]}
					/>
					<h2>Site Plan Submissions</h2>
					<FullTable
						data={this.buildTable()}
						columns={this.buildCols()}
						name="arcManagement__lotPlan"
						title="ARC"
						defaultSorted={[
							{
								id: "date",
								desc: false,
							},
						]}
					/>
					<ArcReviewLot
						open={this.state.modal}
						alert={this.alert}
						id={this.state.id}
						onClose={() => this.setState({ modal: false })}
					/>
					<ArcFinalReview
						open={this.state.finalModal}
						alert={this.alert}
						id={this.state.id}
						notify={this.notify}
						onClose={() => this.setState({ finalModal: false })}
					/>
					<h2>Master Plan Submissions</h2>
					<FullTable
						data={this.buildMaster()}
						columns={this.state.masterColumns}
						name="arcManagement__master"
						title="ARC"
						defaultSorted={[
							{
								id: "date",
								desc: false,
							},
						]}
					/>
					{this.state.masterOpen && (
						<MasterArcModal
							open={this.state.masterOpen}
							data={this.state.masterData}
							alert={this.alert}
							onClose={() => {
								this.setState({ masterOpen: false })
								this.props.getPayload()
							}}
							updateFlare={() => {
								this.props.getPayload()
							}}
							loadingText=""
						/>
					)}
					{settings?.disabled?.finalReview ? null : (
						<>
							<h2>Lot Compliance Review</h2>
							<FullTable
								data={this.buildFinalReview()}
								columns={this.state.finalColumns}
								name="arcManagement__lotFinalReview"
								title="ARC - Final Review"
								defaultSorted={[
									{
										id: "submit_date",
										desc: false,
									},
								]}
							/>
						</>
					)}
					<h2>Lot Info</h2>
					<FullTable
						data={this.buildLots()}
						columns={this.state.lotColumns}
						name="arcManagement__lots"
						title="ARC Lots"
						classNames={"small"}
					/>
					{settings?.disabled?.finalReview ? null : (
						<>
							<h2>Awaiting Final Review</h2>
							<FullTable
								data={this.buildAwaitingFinal()}
								columns={this.state.awaitingFinalColumns}
								name="arcManagement__awaitingFinal"
								title="ARC Awaiting Final Review"
								classNames={"small"}
							/>
						</>
					)}
					<div className="flex justify-between">
						<h2>Materials Management</h2>
						<div className="text-right">
							<i
								className="fa fa-plus-circle text-green-600 text-2xl cursor-pointer"
								onClick={() => {
									this.setState({ materialsOpen: true, materialData: _.clone(this.materialShell) })
								}}
							/>
						</div>
					</div>
					<FullTable
						data={this.buildMaterials()}
						columns={this.state.materials}
						name="arcManagement__materials"
						title="ARC Materials Management"
						classNames={"small"}
						unset={["image"]}
						excelClean={this.excelClean}
					/>
					<div className="flex justify-between">
						<h2>Colors Management</h2>
						<div className="text-right">
							<i
								className="fa fa-plus-circle text-green-600 text-2xl cursor-pointer"
								onClick={() => {
									this.setState({ colorsOpen: true, colorData: _.clone(this.colorShell) })
								}}
							/>
						</div>
					</div>
					<FullTable
						data={this.buildColors()}
						columns={this.state.colors}
						name="arcManagement__colors"
						title="ARC Colors Management"
						classNames={"small"}
						unset={["image"]}
						excelClean={this.excelClean}
					/>
					<h2>Architectural Styles</h2>
					<FullTable
						data={this.buildStyles()}
						columns={this.state.styles}
						name="arcManagement__styles"
						title="ARC Architectural Styles"
						classNames={"small"}
					/>
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.lotInfoModal}
						onClose={() => this.setState({ lotInfoModal: false })}
						center>
						<ArcModal data={this.state.lotData} notify={this.notify} name="lotInfoModal" super={true} />
					</Modal>
					<Modal
						open={this.state.materialsOpen}
						onClose={() => {
							this.setState({ materialsOpen: false })
							this.props.getPayload()
						}}
						center
						classNames={{ modal: "modal__full modal__overflowVis" }}>
						<h3>
							{this.state.materialData?.id ? "Edit Material" : "Add Material"}
							<span
								className="bg-red-500 text-xs py-1 px-2 ml-4 rounded-lg text-white cursor-pointer"
								onClick={async () => {
									if (!this.state.confirmMaterialDisable) {
										this.setState({ confirmMaterialDisable: true })
									} else {
										let resp = await getData("mainIngest", {
											action: "disableMaterial",
											id: this.state.materialData.id,
										})
										if (resp.status === 200) {
											this.props.getPayload()
											this.props.loadingStatus(false)
											toast.success(resp.message)
											this.setState({ materialsOpen: false, confirmMaterialDisable: false })
										}
									}
								}}>
								{this.state.confirmMaterialDisable ? "Confirm?" : "Disable Material"}
							</span>
						</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.materialData}
							validationSchema={this.materialValidation}
							validateOnMount={true}
							onSubmit={(values, { resetForm }) => {
								try {
									this.props.loadingStatus(true)
									let json = JSON.stringify(values)
									var fd = new FormData()
									for (let k in values) {
										fd.append(k, values[k])
									}
									var user = localStorage.getItem("user")
									let req = superagent
										.post(settings.ep + "/arcUpdateMaterial")
										.field("data", json)
										.set("Authorization", user)
									if (typeof values.image === "object") {
										req.attach("image", values.image)
									}
									req.end((err, resp) => {
										if (err) {
											console.log(err)
											toast.error("Error adding material.  Please notify developers.")
											return
										}
										this.props.getPayload()
										this.props.loadingStatus(false)
										toast.success(resp.body.message)
										resetForm()
										if (this.materialFileRef) this.materialFileRef.value = ""
										// If this was an edit of an existing, then close the modal
										if (this.state.materialData.id) {
											this.setState({ materialsOpen: false })
										}
									})
								} catch (e) {
									console.log(e)
								}
							}}>
							{(f) => (
								<div className="">
									<Form>
										{/* console.log(f) */}
										<ul className="form__list">
											<li className={fieldStatus("brand", f)}>
												<label htmlFor="brand">Brand</label>
												{f.errors.brand && f.touched.brand && (
													<div className="form__message">{f.errors.brand}</div>
												)}
												<Field name="brand" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("type", f)}>
												<label htmlFor="type">Material Type</label>
												{f.errors.type && f.touched.type && (
													<div className="form__message">{f.errors.type}</div>
												)}
												<ReactSelect
													name={`type`}
													options={_.sortBy(
														_.map(this.props.payload.public.arc_material_types, (v) => {
															return { value: v.id, label: v.name }
														}),
														"label"
													)}
													value={f.values.type}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("properties", f)}>
												<label htmlFor="properties">Properties</label>
												{f.errors.properties && f.touched.properties && (
													<div className="form__message">{f.errors.properties}</div>
												)}
												<ReactSelect
													name={`properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													isMulti
												/>
											</li>
											<li className={fieldStatus("image", f)}>
												<label htmlFor="image">Image {imageFile}</label>
												{f.errors.image && f.touched.image && (
													<div className="form__message">{f.errors.image}</div>
												)}
												<input
													name="image"
													type="file"
													ref={(ref) => (this.materialFileRef = ref)}
													id="image"
													className="noBorder"
													onChange={(event) => {
														f.setFieldValue("image", event.currentTarget.files[0])
													}}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
					<Modal
						open={this.state.colorsOpen}
						onClose={() => {
							this.setState({ colorsOpen: false })
							this.props.getPayload()
						}}
						center
						classNames={{ modal: "modal__full modal__overflowVis" }}>
						<h3>
							{this.state.colorData?.id ? "Edit Color" : "Add Color"}
							<span
								className="bg-red-500 text-xs py-1 px-2 ml-4 rounded-lg text-white cursor-pointer"
								onClick={async () => {
									if (!this.state.confirmColorDisable) {
										this.setState({ confirmColorDisable: true })
									} else {
										let resp = await getData("mainIngest", {
											action: "disableARCColor",
											id: this.state.colorData.id,
										})
										if (resp.status === 200) {
											this.props.getPayload()
											this.props.loadingStatus(false)
											toast.success(resp.message)
											this.setState({ colorsOpen: false, confirmColorDisable: false })
										}
									}
								}}>
								{this.state.confirmColorDisable ? "Confirm?" : "Disable Color"}
							</span>
						</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.colorData}
							validationSchema={this.colorValidation}
							validateOnMount={true}
							onSubmit={(values, { resetForm }) => {
								try {
									this.props.loadingStatus(true)
									let json = JSON.stringify(values)
									var fd = new FormData()
									for (let k in values) {
										fd.append(k, values[k])
									}
									var user = localStorage.getItem("user")
									let req = superagent
										.post(settings.ep + "/arcUpdateColor")
										.field("data", json)
										.set("Authorization", user)
									if (typeof values.image === "object") {
										req.attach("image", values.image)
									}
									req.end((err, resp) => {
										if (err) {
											console.log(err)
											toast.error("Error adding color.  Please notify developers.")
											return
										}
										this.props.getPayload()
										this.props.loadingStatus(false)
										toast.success(resp.body.message)
										resetForm()
										if (this.colorFileRef) this.colorFileRef.value = ""
										// If this was an edit of an existing, then close the modal
										if (this.state.colorData.id) {
											this.setState({ colorsOpen: false })
										}
									})
								} catch (e) {
									console.log(e)
								}
							}}>
							{(f) => (
								<div className="">
									<Form>
										{/* console.log(f) */}
										<ul className="form__list">
											<li className={fieldStatus("brand", f)}>
												<label htmlFor="brand">Brand</label>
												{f.errors.brand && f.touched.brand && (
													<div className="form__message">{f.errors.brand}</div>
												)}
												<Field name="brand" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("properties", f)}>
												<label htmlFor="properties">Properties</label>
												{f.errors.properties && f.touched.properties && (
													<div className="form__message">{f.errors.properties}</div>
												)}
												<ReactSelect
													name={`properties`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.properties}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
													isMulti
												/>
											</li>
											<li className={fieldStatus("image", f)}>
												<label htmlFor="image">Image {imageFile}</label>
												{f.errors.image && f.touched.image && (
													<div className="form__message">{f.errors.image}</div>
												)}
												<input
													name="image"
													type="file"
													ref={(ref) => (this.colorFileRef = ref)}
													id="image"
													className="noBorder w-full"
													onChange={(event) => {
														f.setFieldValue("image", event.currentTarget.files[0])
													}}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
					<Modal
						open={this.state.stylesOpen}
						onClose={() => {
							this.setState({ stylesOpen: false })
							this.props.getPayload()
						}}
						center
						classNames={{ modal: "modal__full modal__overflowVis" }}>
						<h3>Style Management</h3>
						<p className="text-xs mt-3">
							Please note that if options are selected for the material types below, the builders will be
							limited to whatever options are chosen below. If you leave them blank, then they can choose
							from an option.
						</p>
						<Formik
							enableReinitialize
							initialValues={this.state.styleData}
							//validationSchema={this.materialValidation}
							//validateOnMount={true}
							onSubmit={async (values, { resetForm }) => {
								try {
									this.props.loadingStatus(true)
									let json = JSON.stringify(values)
									let resp = await getData("mainIngest", {
										action: "arcUpdateStyle",
										data: json,
									})
									if (resp.status === 200) {
										this.props.getPayload()
										this.props.loadingStatus(false)
										toast.success(resp.message)
										resetForm()
										this.setState({ stylesOpen: false })
									}
								} catch (e) {
									console.log(e)
								}
							}}>
							{(f) => (
								<div className="">
									<Form>
										{/* console.log(f) */}
										<ul className="form__list">
											<li className={`w-1/2 px-2 pt-6`}>
												<label htmlFor="name">
													Name <sup>*</sup>
												</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field name="name" type="text" className="form__input" />
											</li>
											<li className={`w-1/2 px-2 pt-6`}>
												<label htmlFor="property">Property</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											{this.stylesListMaterialSelects(f)}
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ArcManagement)
